import { PeriodOptionType } from "./types";

export const DEFAULT_PERIOD_OPTION: PeriodOptionType = "last_28_days" as const;

export const PERIOD_OPTIONS = [
  "custom",
  "last_day",
  "last_7_days",
  "last_28_days",
  "last_18_months",
  "prev_month"
];
